import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { withinDateTimeRange } from '@modules/date';
import { formatNotificationBody } from '@modules/react_content';
import imgAlert from '@img/Homepage/Alert.png';
import imgAlert500 from '@img/Homepage/Alert-p-500.png';
import withRouter from '@wrappers/withRouter';

const { VITE_ENV } = import.meta.env;

const ShowNotifications = props => {
	const system_notifications = useSelector(state => state.global.system_notifications),
		[notificationIndex, setNotificationIndex] = useState(0),
		[intervalId, setIntervalId] = useState(-1),
		notifications = useMemo(() => filterNotifications(system_notifications), [system_notifications]);

	useEffect(() => {
		if (notifications.length > 1) {
			let funcSetInterval = setInterval(() => {
				const newIndex = notificationIndex === notifications.length - 1 ? 0 : notificationIndex + 1;
				setNotificationIndex(newIndex);
			}, 5000);

			setIntervalId(funcSetInterval);
		}

		return () => {
			clearInterval(intervalId);
		};
	}, []);

	if (!notifications.length) return <></>;

	return (
		<div className={`announcement-bar${VITE_ENV === 'production' ? '' : ' practice'}`}>
			<div className='announcement-wrap'>
				<img
					src={imgAlert}
					srcSet={`${imgAlert500} 500w, ${imgAlert} 800w`}
					sizes='75px'
					alt=''
					className='announcement-icon'
				/>
				<div className='announcement'>{formatNotificationBody(notifications[notificationIndex])}</div>
			</div>
		</div>
	);
};

const filterNotifications = arr =>
	arr.filter(n => {
		const { field_start_date: start, field_end_date: end, field_display_on_login_screen: on_login } = n || {};
		return !start || !end || (on_login !== '1' && withinDateTimeRange(start, end));
	});

export default withRouter(ShowNotifications);
